import {
  dimensionsRatio,
  setupDocumentDimensions,
} from 'affiny-core/helpers/dimensions';
import { isWeb } from 'affiny-core/helpers/targetCheck/targetCheck';
import rem from '../utils/rem';
import { ISpace } from './ISpaces';

setupDocumentDimensions();

/* Because ReactNative don't support rem */
const isOnWeb = isWeb();

const integerSpacing = {
  xSmallInt: 4 * dimensionsRatio.width,
  smallInt: 8 * dimensionsRatio.width,
  mediumInt: 16 * dimensionsRatio.width,
  largeInt: 24 * dimensionsRatio.width,
  xLargeInt: 32 * dimensionsRatio.width,
};

export const space: ISpace = {
  ...integerSpacing,
  xSmall: isOnWeb
    ? rem(integerSpacing.xSmallInt)
    : `${integerSpacing.xSmallInt}px`,
  small: isOnWeb
    ? rem(integerSpacing.smallInt)
    : `${integerSpacing.smallInt}px`,
  medium: isOnWeb
    ? rem(integerSpacing.mediumInt)
    : `${integerSpacing.mediumInt}px`,
  large: isOnWeb
    ? rem(integerSpacing.largeInt)
    : `${integerSpacing.largeInt}px`,
  xLarge: isOnWeb
    ? rem(integerSpacing.xLargeInt)
    : `${integerSpacing.xLargeInt}px`,
};
